import * as actions from '../utils/Constants';
const api = `${process.env.REACT_APP_API_HOST}api/trainingType/`;

export const getTrainingType = (id) => {
    return {
        type: actions.GET_TRAINING_TYPE,
        payload: fetch(api + id, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        }).then(res => {
            return res.json();
        })
    }
}

export const updateTrainingType = (trainingType) => {
    return {
        type: actions.UPDATE_TRAINING_TYPE,
        payload: fetch(api, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(trainingType),
        }).then(res => {
            if (!res.ok)
                return Promise.reject({ code: res.status, description: res.statusText });

            return res.json();
        }).catch(error => {
            return Promise.reject(error);
        })
    }
}

export const updateTrainingTypeName = (name) => {
    return {
        type: actions.UPDATE_TRAINING_TYPE_NAME,
        payload: name
    }
}

export const updateTrainingTypeDescription = (description) => {
    return {
        type: actions.UPDATE_TRAINING_TYPE_DESCRIPTION,
        payload: description
    }
}
